import React from "react";
import {IconButton} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function DHButtonProgressIcon({ icon, working, disabled, onClick}) {

    return <IconButton color="primary" disabled={working || disabled} size="large" onClick={onClick}>
        {working ? <CircularProgress size={16}/> : icon}
    </IconButton>
}